export default __webpack_public_path__ + "static/media/dimg111.1c810d9f.jpg";